// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Tuu3","col":"styles_col__3mBki"};